import * as React from 'react';
import {
  Unstable_NumberInput as BaseNumberInput,
  NumberInputProps as NumberInputPropsMui,
} from '@mui/base/Unstable_NumberInput';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import {
  StyledButton,
  StyledInput,
  StyledInputRoot,
} from './NumberInput.styles';

type BaseNumberInputDivProps = NumberInputPropsMui<'div'>; 

export interface CustomNumberInputProps
  extends Omit<BaseNumberInputDivProps, 'min' | 'max'> {
  min?: string | number;
  max?: string | number;
}

export const NumberInput = React.forwardRef(function CustomNumberInput(
  { min, max, ...restProps }: CustomNumberInputProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const parsedMin = typeof min === 'string' ? parseFloat(min) : min;
  const parsedMax = typeof max === 'string' ? parseFloat(max) : max;

  return (
    <BaseNumberInput
      component="div"
      ref={ref}
      min={parsedMin}
      max={parsedMax}
      slots={{
        root: StyledInputRoot,
        input: StyledInput,
        incrementButton: StyledButton,
        decrementButton: StyledButton,
      }}
      slotProps={{
        incrementButton: {
          children: <AddIcon fontSize="small" />,
          className: 'increment',
          'data-slot': 'incrementButton',
        } as React.HTMLAttributes<HTMLButtonElement>,
        decrementButton: {
          children: <RemoveIcon fontSize="small" />,
          'data-slot': 'decrementButton',
        } as React.HTMLAttributes<HTMLButtonElement>,
        root: { 'data-slot': 'root' } as React.HTMLAttributes<HTMLDivElement>,
        input: { 'data-slot': 'input' } as React.HTMLAttributes<HTMLDivElement>,
      }}
      {...restProps} // pass everything else
    />
  );
});

NumberInput.displayName = 'NumberInput';